import { CadastreHousingValue as ApiHousingValue } from '../realty/model/CadastreHousingValue';
import { defined, evaluate } from '../utility/Control';
import { CadastreCalculationBasis } from '../realty/model/CadastreCalculationBasis';
import { CadastreHousingValueConveyance as ACHVC } from '../realty/model/CadastreHousingValueConveyance';
import { CadastreHousingValueConveyance } from './CadastreHousingValueConveyance';
import { Cadastre as ApiCadastre } from '../realty/model/Cadastre';
import { Address as ApiAddress } from '../realty/model/Address';
import { Building as ApiBuilding } from '../realty/model/Building';
import { Address } from './Address';
import { Building } from './Building';

export class HousingValue {
  public calculatedValue: number;
  public calculationText: string;
  public pricePerSquareMeter: number;
  public mostRecentFreeMarketConveyance: CadastreHousingValueConveyance;
  public address: string;
  public position: number[];
  public building: Building;
  public cadastreKey: string;

  public constructor(apiHousingValue: ApiHousingValue) {
    this.calculatedValue = apiHousingValue.calculatedValue;
    this.calculationText = apiHousingValue.calculationText;
    const calculationBasis: CadastreCalculationBasis = apiHousingValue.calculationBasis;
    if (defined(calculationBasis)) {
      const totalFloorSpace: number = evaluate(calculationBasis, 'area.totalFloorSpace');
      if (defined(this.calculatedValue, totalFloorSpace) && totalFloorSpace > 0) {
        this.pricePerSquareMeter = Math.floor(this.calculatedValue / totalFloorSpace);
      }
      const conveyance: ACHVC = calculationBasis.conveyance;
      if (defined(conveyance)) {
        this.mostRecentFreeMarketConveyance = new CadastreHousingValueConveyance(conveyance);
        if (!defined(this.mostRecentFreeMarketConveyance.unitType) && defined(calculationBasis.unitType)) {
          this.mostRecentFreeMarketConveyance.unitType = calculationBasis.unitType.text;
        }
      }
    }
    const apiCadastre: ApiCadastre = evaluate(apiHousingValue, 'inclusions.cadastre.item');
    if (defined(apiCadastre)) {
      this.cadastreKey = apiCadastre.key;
      this.position = evaluate(apiCadastre, 'position.geometry.coordinates');
    }
    const apiAddress: ApiAddress = evaluate(apiHousingValue, 'inclusions.presentationAddress.item');
    if (defined(apiAddress)) {
      this.address = new Address(apiAddress).streetAddress;
      const coordinates = evaluate(apiAddress, 'position.geometry.coordinates');
      if (defined(coordinates)) {
        this.position = coordinates;
      }
    }
    const apiBuildings: ApiBuilding[] = evaluate(apiHousingValue, 'inclusions.buildings.items');
    if (defined(apiBuildings) && apiBuildings.length > 0) {
      const apiBuilding = apiBuildings
        .filter((ab: ApiBuilding) => {
          return defined(evaluate(ab, 'typeOfBuilding.code'));
        })
        .sort((ab0: ApiBuilding, ab1: ApiBuilding) => {
          return parseInt(ab0.typeOfBuilding.code, 10) - parseInt(ab1.typeOfBuilding.code, 10);
        })[0];
      this.building = new Building(apiBuilding);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/HousingValue.ts
 **/